<template>
  <div class="adput-group-add">
    <div class="panel-header">
      <h3 class="panel-header__title">广告组管理</h3>
      <span class="panel-header__subtitle">AD GROUP MANAGEMENT</span>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">广告组管理</h3>
      <up-form class="panel-content__form" :model="form" :rules="rules" ref="form" label-width="130px" v-loading="loading" element-loading-text="加载中...">
        <up-form-item-select v-if="platform === 'agency'" label="所属广告主：" prop="advertiser_id" v-model="form.advertiser_id"  :disabled="disabledField" :data="adUsers" placeholder="请选择所属广告主"></up-form-item-select>
        <up-form-item-input class="w364" label="广告组名称：" prop="order_name" v-model="form.order_name" placeholder="请输入广告组名称"></up-form-item-input>
        <up-form-item-radio prop="jump_type" v-model="form.jump_type" :data="jumpTypes" :disabled="disabledField" placeholder="请选择推广目的">
          <template slot="label">推广目的：
            <up-tooltip effect="light" placement="right">
              <div slot="content">选择落地页推广，代表点击广告创意访问落地页。<br/>选择应用下载代表点击广告创意直接下载应用（不支持重定向或者二跳的链接）</div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-radio>
        <up-form-item-radio label="广告预算：" prop="is_budget" v-model="form.is_budget" :data="budgets" placeholder="请选择推广目的"></up-form-item-radio>
        <up-form-item label=" " prop="budget" v-if="form.is_budget === '1'">
          <up-input v-model="form.budget" placeholder="请输入预算" @input.native="handleInputBudget"></up-input>
        </up-form-item>
        <div class="panel-content__btn-group">
          <template v-if="type !== 'view'">
            <div class="panel-content__btn"><up-button size="large" type="primary" @click="submitForm('form')">{{ !next ? btnText('保存') : '保存' }}</up-button></div>
            <div class="panel-content__btn"><up-button size="large" type="primary" @click="submitForm('form', true)">{{ next ? btnText('保存并新建计划') : '保存并新建计划' }}</up-button></div>
          </template>
          <div class="panel-content__btn"><up-button size="large" class="is-cancel" @click="$router.go(-1)">取消</up-button></div>
        </div>
      </up-form>
    </div>
  </div>
</template>

<script>
// import { capturedGet, capturedPost, capturedPut } from '@/agent/http'
import { mapActions } from 'vuex'
import { comdify, delcommafy } from '@/global/util/util'

export default {
  name: 'group-add',
  data () {
    const validateOrderName = async (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入广告组名称'))
      } else if (value.length > 50) {
        callback(new Error('广告组名称不能超过50个字符'))
      } else {
        const [, res] = await this['group/validateOrderName']({ platform: this.platform, value })
        if (
          res.data.status === 1 &&
          (
            ['add', 'copy'].includes(this.type) ||
            (this.type === 'edit' && this.originalOrderName !== value)
          )
        ) {
          callback(new Error('广告组名称已经存在'))
        } else {
          callback()
        }
      }
    }

    const validateBudget = (rule, value, callback) => {
      if (value || value === '0') {
        if (delcommafy(value) < 100) {
          callback(new Error('预算最低100元'))
        } else if (delcommafy(value) > 10000000) {
          callback(new Error('预算不得超过10000000'))
        } else if (!/^[0-9]*[1-9][0-9]*$/.test(delcommafy(value))) {
          // this.form.budget = this.form.budget.replace(/[^\d]/g, '')
          callback(new Error('预算必须是正整数'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入预算'))
      }
    }

    this.budgets = [
      { name: '不限', value: '0' },
      { name: '指定预算', value: '1' }
    ]

    return {
      platform: '',
      id: '',
      type: '',
      originalOrderName: '',
      form: {
        advertiser_id: '',
        order_name: '',
        jump_type: '',
        is_budget: '',
        budget: ''
      },
      rules: {
        advertiser_id: [{ required: true, message: '请选择所属广告主', trigger: 'change' }],
        order_name: [{ required: true, validator: validateOrderName, trigger: 'blur' }],
        jump_type: [{ required: true, message: '请选择推广目的', trigger: 'change' }],
        is_budget: [{ required: true, message: '请选择广告组预算', trigger: 'change' }],
        budget: [{ type: 'number', validator: validateBudget, trigger: 'blur' }]
      },
      adUsers: [],
      jumpTypes: [],
      submited: false,
      submiting: false,
      verifying: false,
      next: false,
      loading: false
    }
  },
  computed: {
    btnText () {
      return function (text) {
        return this.submiting ? `${text}中...` : this.submited ? `已${text}` : text
      }
    },
    disabledField () {
      return ['edit', 'view'].includes(this.type)
    }
  },
  methods: {
    ...mapActions([
      'group/validateOrderName',
      'group/getAdUsers',
      'group/getJumpTypes',
      'group/submitForm',
      'group/created'
    ]),
    handleInputBudget () {
      this.$nextTick(() => {
        if (this.form.budget) {
          this.form.budget = comdify(delcommafy(this.form.budget))
        }
      })
    },
    async getAdUsers () {
      const [err, res] = await this['group/getAdUsers']({ platform: this.platform })
      if (err || res.code !== 1) this.$message.error('获取广告主列表失败')
      else {
        this.adUsers = res.code === 1 ? res.data : []
      }
    },
    async getJumpTypes () {
      const [err, res] = await this['group/getJumpTypes']()
      if (err) this.$message.error('获取推广目的失败')
      else {
        this.jumpTypes = res.code === 1 ? res.data : []
        if (this.form.jump_type !== '3') {
          this.jumpTypes = this.jumpTypes.filter(item => item.value !== '3')
        }
      }
    },
    submitForm (formName, next) {
      if (this.verifying) return
      this.verifying = true
      if (this.submited || this.submiting) return this.$message.error('请勿重复提交数据！')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.next = next
          this.submiting = true
          this.verifying = false

          const text = this.type === 'edit' ? '修改' : this.type === 'copy' ? '复制' : '添加'
          // 广告主平台移除
          if (this.platform !== 'agency') this.$delete(this.form, 'advertiser_id')
          const { budget, ...formData } = this.form
          if (formData.is_budget === '1') {
            formData.budget = delcommafy(budget)
          }
          const [err, res] = await this['group/submitForm']({ platform: this.platform, type: this.type, id: this.id, form: formData })
          this.submiting = false
          if (err) return this.$message.error(`${text}广告组失败`)
          else if (res.code !== 1) {
            return this.$message.error(res.msg)
          } else {
            this.submited = true
            this.$message.success(`${text}广告组成功`)
            setTimeout(_ => this.$router.push(next ? '/plan/add' : '/groups'), 2000)
          }
        } else {
          this.$message.error('请填写完整信息！')
          this.verifying = false
          return false
        }
      })
    }
  },
  async created () {
    const { type, id = '' } = this.$route.params
    this.platform = this.$route.meta.platform
    this.type = type
    this.id = id
    this.loading = true
    if (this.platform === 'agency') this.getAdUsers()
    this.getJumpTypes()

    if (this.id) {
      const [err, res] = await this['group/created']({ platform: this.platform, id: this.id })
      if (err) this.$message.error('获取广告组信息失败！')
      else {
        const { advertiser_id: advertiserId, order_name: orderName, jump_type: jumpType, is_budget: isBudget, budget = '' } = res.data
        this.originalOrderName = orderName
        this.form = Object.assign({}, this.form, {
          advertiser_id: advertiserId,
          order_name: orderName, // this.type !== 'copy' ? orderName : `${orderName}_${+new Date()}`,
          jump_type: jumpType,
          is_budget: isBudget,
          budget: comdify(budget)
        })
      }
    }
    this.loading = false
  }
}
</script>

<style lang="scss">
@include b(adput-group-add) {
  .icon-iconfontquestion {
    color: #fc8675;
  }
}
</style>
